<script lang="ts">
declare global {
  interface Window {
    jsForDetect?: boolean;
  }
}
window.jsForDetect = true;
</script>

<script lang="ts" setup>
import { ref } from "vue";
import { useGlobalData } from "@/utils/useGlobal";
import { getConfigData, guideCategory } from "./api";
import { NMessageProvider } from "naive-ui";
import VideoPlayer from "./coms/VideoPlayer.vue";
import { loading } from "@/utils/global";
import TopBar from "./coms/m/TopBar.vue";
import GiftBag from "./coms/GiftCodePop.vue";
import { track } from "@/libs/track";

const {
  isPc,
  config,
  newsTabsList,
  isShowDownloadButton,
  guideCategoryList,
  videoUrl,
} = useGlobalData();
const appClass = isPc.value ? "pc" : "wap";
const env = import.meta.env.MODE === "prd" ? "prd" : "stg";
const dataLoading = ref(true);
let timer: ReturnType<typeof setTimeout>;
const now_date = new Date().getTime();
// 获取页面配置信息
async function getConfig() {
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    loading.show();
  }, 1000);
  try {
    let res = await getConfigData<IConfig>("base", {
      group: env,
    });
    if (res.length && res[0]) {
      config.value = res[0];
      // 检测是否显示下载按钮
      if (config.value.socialMedia?.downloadOpenDate.length > 0) {
        // 确保数组至少有两个元素
        const startDate = config.value.socialMedia.downloadOpenDate[0];
        const endDate = config.value.socialMedia.downloadOpenDate[1];

        if (startDate === null && endDate === null) {
          isShowDownloadButton.value = true;
          return;
        }
        if (now_date < startDate || now_date > endDate) {
          // 隐藏下载按钮
          isShowDownloadButton.value = false;
          return;
        }
        isShowDownloadButton.value = true;
      }
    }
  } catch (e) {
    console.log("getConfigData error", e);
  } finally {
    if (timer) clearTimeout(timer);
    loading.hide();
    dataLoading.value = false;
  }
}
getConfig();

// 获取新闻类型
(async () => {
  const items = await getConfigData<NewsTypeData>("columns");
  if (items.length === 0) return;
  newsTabsList.value = items.reverse();
})();

// 获取攻略类型

(async () => {
  const res = await guideCategory();
  guideCategoryList.value = res;
})();

track.trackPageView();
</script>

<template>
  <n-message-provider>
    <div class="app" :class="appClass">
      <div v-if="!isPc" class="view-direction-tip">请竖屏观看</div>
      <template v-if="!dataLoading">
        <TopBar />
        <router-View></router-View>
        <!-- 首页顶部视频弹窗 -->
        <VideoPlayer :src="videoUrl" />
      </template>
      <GiftBag />
    </div>
  </n-message-provider>
</template>

<style lang="less">
html,
body {
  position: relative;
  height: 100%;
  background-color: #231b19 !important;
}
#app {
  height: 100%;
  font-family: "HYJiangNanKaiSong, Microsoft YaHei", Avenir, Helvetica, Arial,
    sans-serif;
  font-size: 0.14rem;
  color: #fff;
}
.pc,
.wap {
  height: 100%;
}

button {
  cursor: pointer;
}

.n-pagination-item {
  &:hover {
    color: #fff !important;
  }
}
.n-pagination .n-pagination-item,
.n-pagination .n-pagination-item.n-pagination-item--button {
  color: #fff;
  &:hover {
    svg {
      color: #fff;
    }
  }
}
.n-pagination
  .n-pagination-item:not(
    .n-pagination-item--disabled
  ).n-pagination-item--active {
  color: #333333;
  background-color: #fff;
  border-color: #c8c8c8;
  &:hover {
    color: #fff;
    background-color: #333333;
  }
}

.n-pagination
  .n-pagination-item.n-pagination-item--disabled.n-pagination-item--active,
.n-pagination
  .n-pagination-item.n-pagination-item--disabled.n-pagination-item--button {
  background-color: transparent;
  opacity: 0.5;
}
.global-toast {
  padding: 0.2rem 0.3rem !important;
  font-size: 0.24rem;
}
.wap {
  .view-direction-tip {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9;
    display: none;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    font-size: 0.3rem;
    color: #fff;
    text-align: center;
    background-color: #000;
  }

  @media screen and (orientation: landscape) {
    .view-direction-tip {
      z-index: 999;
      display: flex;
    }
  }
}
</style>
